var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmoji4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8771 31.7542C24.6458 31.7542 31.7542 24.6458 31.7542 15.8771C31.7542 7.10842 24.6458 0 15.8771 0C7.10842 0 0 7.10842 0 15.8771C0 24.6458 7.10842 31.7542 15.8771 31.7542Z",
    fill: "#FFDD67"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79084 14.5541C11.2523 14.5541 12.437 13.3693 12.437 11.9079C12.437 10.4465 11.2523 9.26172 9.79084 9.26172C8.32939 9.26172 7.14465 10.4465 7.14465 11.9079C7.14465 13.3693 8.32939 14.5541 9.79084 14.5541Z",
    fill: "#664E27"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9633 14.5541C23.4248 14.5541 24.6095 13.3693 24.6095 11.9079C24.6095 10.4465 23.4248 9.26172 21.9633 9.26172C20.5019 9.26172 19.3171 10.4465 19.3171 11.9079C19.3171 13.3693 20.5019 14.5541 21.9633 14.5541Z",
    fill: "#664E27"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8742 19.0523C24.8742 18.6289 24.6096 18.0997 23.9215 17.9409C22.0692 17.5705 19.3701 17.2529 15.8772 17.2529C12.3842 17.2529 9.68508 17.6234 7.83275 17.9409C7.14474 18.0997 6.88013 18.6289 6.88013 19.0523C6.88013 22.9158 9.84385 26.7792 15.8772 26.7792C21.9104 26.7792 24.8742 22.9158 24.8742 19.0523Z",
    fill: "#664E27"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5984 19.2114C21.434 18.9997 18.9996 18.6821 15.8771 18.6821C12.7546 18.6821 10.3201 18.9997 9.15575 19.2114C8.46774 19.3172 8.41482 19.5818 8.46774 20.0052C8.52066 20.2169 8.52066 20.5345 8.62651 20.852C8.67943 21.1695 8.78528 21.3283 9.31452 21.2754C10.3201 21.1695 21.487 21.1695 22.4925 21.2754C23.0217 21.3283 23.0747 21.1695 23.1805 20.852C23.2334 20.5345 23.2864 20.2698 23.3393 20.0052C23.3393 19.5818 23.2864 19.3172 22.5984 19.2114Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoji4);
export default __webpack_public_path__ + "static/media/emoji4.6f578c02bc9606b8110d4c385607163c.svg";
export { ForwardRef as ReactComponent };